// pages/NotAuthorized.js
const NotAuthorized = () => (
  <div style={{ padding: "2rem", textAlign: "center" }}>
    <h1>403 - Not Authorized</h1>
    <p>You are not allowed to view this page.</p>
  </div>
);

export default NotAuthorized;